import React, { useState, useContext, useEffect } from "react";
import $ from "jquery";
import PsContext from "../../../context";
import { Alert, Button, Card, Col, Form, Row } from "react-bootstrap";
import StepMenu from "../stepMenu";
import {
  capitalizeFirst,
  upperCase,
  S3_BUCKET_HOME_PATH,
  DB_POSTFIX,
} from "../../../utils";
import axios from "axios";
import { ServiceUrl } from "../../../utils/serviceUrl";
import { toast } from "react-hot-toast";
import { Spin } from "antd";
import { Link } from "react-router-dom";

const CourseApply = (props) => {
  const context = useContext(PsContext);

  const [activeTab, setActiveTab] = useState(null);
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [applicant, setApplicant] = useState([]);

  const [courseList, setCourseList] = useState([]);
  const [appliedCourses, setAppliedCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState([]);

  const [paymentLink, setPaymentLink] = useState([]);

  // Display filter: null = show all, "regular" = only regular, "self" = only self
  const [displayType, setDisplayType] = useState(null);
  const [regularCourses, setRegularCourses] = useState([]);
  const [selfCourses, setSelfCourses] = useState([]);

  useEffect(() => {
    loadApplicantInfo();
    loadAllCoursesForDisplay();
  }, []);

  useEffect(() => {
    if (applicant) {
      if (context.settingValue("admission_has_pg_regular") != "0")
        setActiveTab("regular");
      else if (context.settingValue("admission_has_pg_self") != "0")
        setActiveTab("self");
    }
  }, [applicant]);

  const getApplicant = (fieldName) => {
    try {
      if (applicant && applicant[fieldName]) return applicant[fieldName];
    } catch (er) {}
  };

  const loadApplicantInfo = () => {
    try {
      setLoader(true);
      setApplicant([]);
      var form = new FormData();
      form.append("i__apiCode", context.user.api_code);
      axios.post(ServiceUrl.PG.APPLICANT_MIN_INFO, form).then((res) => {
        if (res["data"].status == "1") {
          let d = res["data"].data;

          setApplicant(d);
          setLoader(false);
        } else {
          toast.error(res["data"].message || "error");
          setLoader(false);
        }
      });
    } catch (error) {
      setLoader(false);
    }
  };

  const loadAllCoursesForDisplay = () => {
    const form1 = new FormData();
    form1.append("i__apiCode", context.user.api_code);
    form1.append("i__courseType", "regular");
    axios.post(ServiceUrl.PG.COURSE_FOR_ME, form1).then((res1) => {
      if (res1["data"].status == "1") {
        setRegularCourses(res1["data"].data || []);

        const form2 = new FormData();
        form2.append("i__apiCode", context.user.api_code);
        form2.append("i__courseType", "self");
        axios.post(ServiceUrl.PG.COURSE_FOR_ME, form2).then((res2) => {
          if (res2["data"].status == "1") {
            setSelfCourses(res2["data"].data || []);

            // Merge applied courses from both responses
            const applied1 = res1["data"].applied_course || [];
            const applied2 = res2["data"].applied_course || [];
            const combined = [...applied1, ...applied2];
            // Make unique by course_id
            const uniqueApplied = Array.from(
              new Map(combined.map((item) => [item.course_id, item])).values(),
            );
            setAppliedCourses(uniqueApplied);
          }
        });
      }
    });
  };

  const getDisplayCourses = () => {
    if (displayType === "regular") return regularCourses;
    if (displayType === "self") return selfCourses;
    return [...regularCourses, ...selfCourses];
  };

  const renderSingleCourseTable = (
    courses,
    title = null,
    isCompact = false,
    showPreference = false,
    showSelect = true,
  ) => {
    return (
      <div className="table-responsive ">
        {title && (
          <div className="py-2 px-3 bg-xav-light border-bottom">
            <h6 className="mb-0 fs-14 fw-800 text-uppercase text-black text-center letter-spacing-1">
              {title}
            </h6>
          </div>
        )}
        <table className="compact-admission-table m-0">
          <thead>
            <tr>
              <th>Name of the Programme</th>
              <th width="190">Programme Timing</th>
              {showPreference && (
                <th width="80" className="text-center">
                  Pref
                </th>
              )}
              {showSelect && (
                <th width="90" className="text-end pe-3">
                  Amount
                </th>
              )}
              {showSelect && (
                <th className="text-center" width="90">
                  Select
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {courses.length === 0 ? (
              <tr>
                <td
                  colSpan={showSelect ? (showPreference ? 5 : 4) : 2}
                  className="text-center py-4 text-black fs-12"
                >
                  No courses available
                </td>
              </tr>
            ) : (
              courses.map((item, i) => (
                <tr
                  key={i}
                  className={
                    checkCourseApplied(item.id)
                      ? "bg-primary-light"
                      : getSelectedCoursePreference(item.id)
                        ? "bg-success-light"
                        : ""
                  }
                >
                  <td
                    className="fw-bold text-uppercase ps-3 text-dark fs-12"
                    height={40}
                  >
                    {item.degreename} - {item.name}
                    {item.coursetype == "self" && " (SF)"}
                    {(item.degreename == "MCA" || item.degreename == "MBA") && (
                      <>
                        {" "}(
                        <span
                          style={{
                            color: "green",
                            fontWeight: "bold",
                          }}
                        >
                          AICTE Approved
                        </span>
                        )
                      </>
                    )}
                  </td>
                  <td className="text-theme fw-bold fs-11">
                    {item.course_timing}
                  </td>
                  {showPreference && (
                    <td align="center">
                      <span
                        className={
                          getSelectedCoursePreference(item.id)
                            ? "fw-bold text-black fs-12"
                            : "fs-12"
                        }
                      >
                        {getSelectedCoursePreference(item.id) || "-"}
                      </span>
                    </td>
                  )}
                  {showSelect && (
                    <td align="right" className="fw-bold pe-3 fs-12">
                      &#8377;{" "}
                      {isScCandidate()
                        ? item.application_fee_sc
                        : item.application_fee_oc}
                    </td>
                  )}
                  {showSelect && (
                    <td align="center">
                      {checkCourseApplied(item.id) ? (
                        <span className="fs-10 fw-bold text-uppercase bg-success text-white px-3 py-1">
                          Selected
                        </span>
                      ) : getSelectedCoursePreference(item.id) ? (
                        <Button
                          type="button"
                          size="sm"
                          variant="outline-success"
                          className="fs-9 py-1 px-2 rounded-0 fw-bold"
                          disabled
                          style={{ minWidth: "70px" }}
                        >
                          Selected
                        </Button>
                      ) : item.degreename == "MBA" && S3_BUCKET_HOME_PATH != "xiba/" ? (
                        <a
                          href="https://www.xibasxc.com/"
                          target="_blank"
                          rel="noreferrer"
                          className="fs-9 py-1 px-2 text-decoration-none"
                          style={{ color: "#ff4b2b", fontWeight: "bold" }}
                        >
                          Refer to XIBA
                        </a>
                      ) : (
                        <Button
                          type="button"
                          size="sm"
                          className="fs-9 py-1 px-2 btn-pay-compact rounded-0"
                          onClick={(e) => handleCourseSelect(item)}
                          style={{ minWidth: "70px" }}
                        >
                          Select
                        </Button>
                      )}
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    );
  };

  const checkCourseApplied = (courseId) => {
    try {
      let index = appliedCourses.findIndex(
        (item) => item.course_id == courseId,
      );
      return index > -1 ? true : false;
    } catch (error) {
      return false;
    }
  };

  /** Common values from settings */
  const maxCourseSelection = () =>
    activeTab == "regular"
      ? context.settingValue("admission_pg_regular_max_course_selection")
      : context.settingValue("admission_pg_self_max_course_selection");

  const applicationFeeForScCandidates = () =>
    (selectedCourse &&
      selectedCourse.length > 0 &&
      selectedCourse[0]["application_fee_sc"]) ||
    "0";

  const applicationFeeForOtherCandidates = () =>
    (selectedCourse &&
      selectedCourse.length > 0 &&
      selectedCourse[0]["application_fee_oc"]) ||
    "0";

  const applicationFee = () => {
    return isScCandidate()
      ? applicationFeeForScCandidates()
      : applicationFeeForOtherCandidates();
  };

  const isScCandidate = () => {
    let community = upperCase(applicant.community);
    let dnomDalit =
      upperCase(applicant.denomination) ==
        upperCase(context.settingValue("clg_admission_denomination")) &&
      applicant.is_dalit == "1";

    return community == "SC" ||
      community == "SCA" ||
      community == "ST" ||
      (community == "BC" && dnomDalit)
      ? true
      : false;
  };

  const firstFreeForSc = () =>
    activeTab == "regular"
      ? context.settingValue("admission_pg_regular_first_free_for_sc")
      : false;

  /** Common values from settings */

  const handleCourseSelect = (course) => {
    if (checkCourseApplied(course.id)) {
      toast.error("You have already applied for this programme.");
      return;
    }

    if (getSelectedCoursePreference(course.id)) {
      return;
    }

    // If selecting a course of a different type than already selected, reset selection
    if (
      selectedCourse.length > 0 &&
      selectedCourse[0].coursetype !== course.coursetype
    ) {
      if (
        window.confirm(
          `You have already selected ${selectedCourse[0].coursetype} courses. Switching to ${course.coursetype} will reset your current selection. Do you want to proceed?`,
        )
      ) {
        setSelectedCourse([course]);
        setActiveTab(course.coursetype);
      }
      return;
    }

    setActiveTab(course.coursetype);
    let max =
      course.coursetype == "regular"
        ? context.settingValue("admission_pg_regular_max_course_selection")
        : context.settingValue("admission_pg_self_max_course_selection");

    let s = [...selectedCourse];
    if (s.length >= parseInt(max)) {
      toast.error(`Your are eligible to select ${max} courses only at a time.`);
      toast.success(
        "Please click pay now button at bottom and then select another course for apply",
      );
      return;
    }
    s.push(course);
    setSelectedCourse(s);
  };

  const getSelectedCoursePreference = (courseId) => {
    try {
      let index = selectedCourse.findIndex((item) => item.id == courseId);
      return index > -1 ? index + 1 : false;
    } catch (er) {
      console.log(er);
      return false;
    }
  };

  const resetPreference = () => setSelectedCourse([]);

  const handleFormSubmit = (e) => {
    e.preventDefault();

    if (selectedCourse.length < 1) {
      toast.error("Please select at least one course to apply");
      return;
    }
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      toast.error("Plese check all the fields filled");
      return;
    }

    if (
      !window.confirm(
        "Please check your course preference before processing. Do you want to proceed to next?",
      )
    )
      return;

    context.setLoader(true);

    axios.post(ServiceUrl.PG.COURSE_APPLY, new FormData(form)).then((res) => {
      if (res["data"].status == "1") {
        context.updateUser(res["data"].user);
        setPaymentLink(res["data"].data);
        if (res["data"].data && res["data"].data.access_code) {
          // document.getElementById("redirect").submit();
        } else {
          context.setLoader(false);
          props.history.push("/");
        }
        //props.history.push("/");
      } else {
        toast.error(res["data"].message || "Error");
        context.setLoader(false);
      }
    });
  };

  useEffect(() => {
    if (paymentLink && paymentLink.access_code) {
      if (paymentLink.type == "ccavenue") {
        document.getElementById("redirect").submit();
      } else if (paymentLink.type == "techprocess") {
        window.location = paymentLink.reqdata;
      }
    }
  }, [paymentLink]);

  const community = upperCase(getApplicant("community"));

  const getPaymentMethodAndAmount = () => {
    let freeAppcount = context.settingValue("pg_sc_free_applications");
    console.log(isScCandidate());
    console.log(appliedCourses.length);
    console.log(freeAppcount);
    if (isScCandidate() && appliedCourses.length < freeAppcount) {
      return (
        <>
          <input type="hidden" name="i__fee" value="0" />
          <Row className="mt-2">
            <Col md={6}></Col>
            <Col md={6} className="text-end">
              <input
                type="radio"
                name="i__paymentMethod"
                value="direct"
                required
                defaultChecked={true}
                className="me-2"
              />
              Note: SC, ST, SCA and Dalit Christians can receive maximum of
              Three Applications free of Application Fees.
            </Col>
          </Row>
        </>
      );
    } else if (isScCandidate() && applicationFee() == 0) {
      return (
        <>
          <input type="hidden" name="i__fee" value="0" />
          <Row className="mt-2">
            <Col md={6}></Col>
            <Col md={6} className="text-end">
              <input
                type="radio"
                name="i__paymentMethod"
                value="direct"
                required
                defaultChecked={true}
                className="me-2"
              />
              No payment for SC/ST/SCA students
            </Col>
          </Row>
        </>
      );
    } else if (applicationFee() == 0) {
      return (
        <>
          <input type="hidden" name="i__fee" value="0" />
          <Row className="mt-2">
            <Col md={6}></Col>
            <Col md={6} className="text-end">
              <input
                type="radio"
                name="i__paymentMethod"
                value="direct"
                required
                defaultChecked={true}
                className="me-2"
              />
              No payment
            </Col>
          </Row>
        </>
      );
    } else {
      return (
        <>
          <Row>
            <Col md={10} className="text-end">
              <label>Application Fee</label>
            </Col>
            <Col md={2}>
              <Form.Control
                type="text"
                className="fw-bold text-end"
                size="sm"
                name="i__fee"
                required
                value={applicationFee()}
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={6}></Col>
            <Col md={6} className="text-end">
              <input
                type="radio"
                name="i__paymentMethod"
                value="online"
                required
                defaultChecked={true}
                className="me-2"
              />
              Online (Debit Card/ Credit Card/ Net Banking/ Wallet/ UPI)
            </Col>
          </Row>
        </>
      );
    }
  };

  const submitBtnText = () => {
    let freeAppcount = context.settingValue("pg_sc_free_applications");
    if (isScCandidate() && appliedCourses.length < freeAppcount)
      return "Confirm Now";
    else if (isScCandidate() && applicationFee() == 0) return "Confirm Now";
    else if (applicationFee() == 0) return "Confirm Now";
    else return "Pay Now";
  };

  return (
    <>
      <div className="container-fluid mb-3">
        <Row>
          <Col md={{ span: 12, offset: 0 }} className="px-5">
            <StepMenu activeKey="step4" />
            <Spin spinning={loader}>
              {DB_POSTFIX == "acas" && (
                <div>
                  <Alert variant="danger" className="bg-red-100">
                    Kindly select the list of program choices required, before
                    clicking 'Pay Now' Button.
                  </Alert>
                </div>
              )}
              {upperCase(submitBtnText()) == "CONFIRM NOW" &&
                S3_BUCKET_HOME_PATH == "sxctvl/" && (
                  <div>
                    <Alert variant="danger" className="bg-red-100 red-box">
                      SC/ST/SCA and Christian Dalit students are eligible to
                      apply for up to one course free of charge. Your
                      applications will be processed and approved within 24
                      hours.
                    </Alert>
                  </div>
                )}
              <Row className="g-0 mb-0">
                {context.settingValue("admission_has_pg_regular") != "0" && (
                  <Col
                    md={
                      context.settingValue("admission_has_pg_self") != "0"
                        ? 6
                        : 12
                    }
                  >
                    <button
                      type="button"
                      className="w-100 py-3 fw-800 fs-15 border-0 text-white letter-spacing-1"
                      style={{
                        backgroundColor: "#021a46",
                        cursor: "pointer",
                        transition: "background-color 0.2s",
                        boxShadow:
                          displayType === "regular"
                            ? "inset 0 -4px 0 rgba(0,0,0,0.2)"
                            : "none",
                      }}
                      onClick={() => {
                        setDisplayType(
                          displayType === "regular" ? null : "regular",
                        );
                        setActiveTab("regular");
                        setSelectedCourse([]);
                      }}
                    >
                      {displayType === "regular" && (
                        <i className="fa-solid fa-check-circle me-2"></i>
                      )}
                      Click here to Apply for Aided Programme
                    </button>
                  </Col>
                )}
                {context.settingValue("admission_has_pg_self") != "0" && (
                  <Col
                    md={
                      context.settingValue("admission_has_pg_regular") != "0"
                        ? 6
                        : 12
                    }
                  >
                    <button
                      type="button"
                      className="w-100 py-3 fw-800 fs-15 border-0 text-white letter-spacing-1"
                      style={{
                        backgroundColor: "#680013",
                        cursor: "pointer",
                        transition: "background-color 0.2s",
                        boxShadow:
                          displayType === "self"
                            ? "inset 0 -4px 0 rgba(0,0,0,0.2)"
                            : "none",
                      }}
                      onClick={() => {
                        setDisplayType(displayType === "self" ? null : "self");
                        setActiveTab("self");
                        setSelectedCourse([]);
                      }}
                    >
                      {displayType === "self" && (
                        <i className="fa-solid fa-check-circle me-2"></i>
                      )}
                      Click here to Apply for Self Financed Programme
                    </button>
                  </Col>
                )}
              </Row>

              <Card
                className="border-0 rounded-0 overflow-hidden shadow-none"
                style={{ background: "#f7f7f7" }}
              >
                <Card.Body className="p-0 pt-2">
                  {selectedCourse && selectedCourse.length > 0 ? (
                    <>
                      {renderSingleCourseTable(
                        selectedCourse,
                        "Selected Programme(s)",
                        true,
                        true,
                      )}
                      <div className="bg-white p-2 text-center border-bottom">
                        <Button
                          variant="link"
                          className="fs-12 fw-bold text-theme text-decoration-none py-0 shadow-none"
                          onClick={() => setSelectedCourse([])}
                        >
                          <i className="fa-solid fa-pen-to-square me-1"></i>{" "}
                          Change Selection
                        </Button>
                      </div>
                    </>
                  ) : displayType === null ? (
                    <Row className="gx-0">
                      <Col md={6} className="border-end">
                        {renderSingleCourseTable(
                          regularCourses,
                          "Aided Programmes (Regular)",
                          true,
                          false,
                        )}
                      </Col>
                      <Col md={6}>
                        {renderSingleCourseTable(
                          selfCourses,
                          "Self Financed Programmes",
                          true,
                          false,
                        )}
                      </Col>
                    </Row>
                  ) : (
                    renderSingleCourseTable(
                      getDisplayCourses(),
                      null,
                      true,
                      true,
                    )
                  )}
                  {selectedCourse && selectedCourse.length > 0 && (
                    <div className="p-3 border-top bg-white">
                      <Form action="" method="post" onSubmit={handleFormSubmit}>
                        <input
                          type="hidden"
                          name="i__userId"
                          value={context.user.user_id}
                        />
                        <input
                          type="hidden"
                          name="i__userCode"
                          value={context.user.user_code}
                        />
                        <input
                          type="hidden"
                          name="i__apiCode"
                          value={context.user.api_code}
                        />
                        <input
                          type="hidden"
                          name="i__courseType"
                          value={activeTab}
                        />
                        <input
                          type="hidden"
                          name="i__courseApply"
                          value={JSON.stringify(selectedCourse)}
                        />
                        {getPaymentMethodAndAmount()}
                        <Row className="gx-0 mb-1">
                          <Col
                            md={10}
                            className="text-end d-flex align-items-center justify-content-end pe-3"
                          >
                            <label className="fs-12 fw-bold text-muted text-uppercase mb-0">
                              Application Fee
                            </label>
                          </Col>
                          <Col md={2}>
                            <Form.Control
                              type="text"
                              className="fw-bold text-end border-0 bg-light rounded-0 fs-14"
                              size="sm"
                              name="i__fee"
                              required
                              readOnly
                              value={applicationFee()}
                            />
                          </Col>
                        </Row>

                        <Row className="mt-4 gx-3">
                          <Col md={6}></Col>
                          <Col md={3}>
                            <Link
                              to="/"
                              className="btn btn-danger btn-sm w-100 py-2 fs-12 rounded-0 shadow-none border-0"
                              onClick={(e) => setSelectedCourse([])}
                            >
                              Cancel
                            </Link>
                          </Col>
                          <Col md={3}>
                            <Button
                              type="submit"
                              size="sm"
                              className="w-100 btn-pay-compact py-2 fs-12 rounded-0 shadow-none border-0"
                            >
                              {submitBtnText()}
                            </Button>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Spin>
          </Col>
        </Row>
      </div>

      {paymentLink && paymentLink.access_code && (
        <form
          method="post"
          name="redirect"
          id="redirect"
          action="https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction"
        >
          <input type="hidden" name="encRequest" value={paymentLink.reqdata} />
          <input
            type="hidden"
            name="access_code"
            value={paymentLink.access_code}
          />
        </form>
      )}
    </>
  );
};

export default CourseApply;
